module.exports = __webpack_public_path__ + "img/defaultCover.e094f400.png";